import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import Swal from 'sweetalert2';
import md5 from 'blueimp-md5';

@Component({
  selector: 'app-cambiar-clave-dialog',
  templateUrl: './cambiar-clave-dialog.component.html',
  styleUrls: ['./cambiar-clave-dialog.component.scss']
})
export class CambiarClaveDialogComponent implements OnInit {

  clave:string='';
  claveActual:string='';
  repetirClave:string='';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CambiarClaveDialogComponent>,
    private restProvider:RestProviderService,
    public sharedService:SharedService

  ) { }

  ngOnInit(): void {
  }
  public cerrar(){
    this.dialogRef.close();
  }

  public validarCampos(){
    return !(this.claveActual && this.clave && this.clave.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*., ?]).+$') && this.repetirClave && this.repetirClave.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*., ?]).+$') && this.clave.length>=8 && this.repetirClave.length>=8);
  }

  public actualizarClave(){
    if(this.clave && this.repetirClave && this.clave == this.repetirClave){
      Swal.fire({
        title: 'Cambiar contraseña',
        text: "¿Seguro de cambiar contraseña?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          let params={
            data:{
              id:this.sharedService.userSession.id,
              password:md5(this.claveActual),
              newPassword:this.clave
            }
          }
          this.restProvider.executeHttpMethod("/uc/ac",params).subscribe((result:any)=>{
            if(result.data){
              this.sharedService.userSession.estado=result.data.estado;
              this.sharedService.userSession.password=result.data.password;
              let sessionUser: any = JSON.parse(JSON.stringify(this.sharedService.userSession));
              sessionStorage.setItem('SESSION_USER', JSON.stringify(sessionUser));
              Swal.fire({
                title:'Contraseña actualizada!',
                text:result.responseMessage,
                icon:'success',
                showConfirmButton: false,
                timer: 1800
              }).then((result)=>{
                this.cerrar();
              });
            }
          }, error => {
            console.error(error);
            this.sharedService.showMessageWarn('La contraseña actual es incorrecta');
          });
        }
      });
    }else{
      this.sharedService.messageWarn.next();
      this.sharedService.showMessageWarn('La nueva contraseña debe ser igual a la confirmación');
    }
  }
}


